import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

function isStaffAppPath () {
  const p = window.location.pathname
  return p.startsWith('/hub') || p.startsWith('/scheduler')
}

/**
 * Keep the crawlable #seo-shell until the SPA paints real page chrome on marketing routes.
 * Staff apps (/hub, /scheduler) remove it immediately — they never need that shell.
 */
function removeSeoShellWhenReady () {
  const seoShell = document.getElementById('seo-shell')
  if (!seoShell) return

  if (isStaffAppPath()) {
    seoShell.remove()
    return
  }

  const root = document.getElementById('root')
  const tryRemove = () => {
    if (!root) {
      seoShell.remove()
      return true
    }
    // Prefer main/header from a finished page over the temporary Loading… spinner
    if (root.querySelector('main, header, nav, [data-seo-ready]')) {
      seoShell.remove()
      return true
    }
    return false
  }

  if (tryRemove()) return

  const observer = new MutationObserver(() => {
    if (tryRemove()) observer.disconnect()
  })
  observer.observe(root, { childList: true, subtree: true })
  window.setTimeout(() => {
    observer.disconnect()
    seoShell.remove()
  }, 10000)
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

removeSeoShellWhenReady()
